<template>
  <div class="roam">
    <img
      src="../assets/images/items/item2/quit.png"
      alt=""
      class="img1"
      @click="goAbout"
    />
    <iframe frameborder="0" ref="iframe"></iframe>
  </div>
</template>

<script>
export default {
  mounted() {
    // console.log(this.$route.params);
    if (this.$route.params.name == "RZFY") {
      this.$refs.iframe.src = "http://gwc.bjthua.com/rzfypano/com/tour.html";
    }
    else if (this.$route.params.name == "DXQNY") {
      this.$refs.iframe.src = "http://gwc.bjthua.com/dxqnypano/com/tour.html";
    }
    else if (this.$route.params.name == "GDYH") {
      this.$refs.iframe.src = "http://gwc.bjthua.com/gdyhpano/com/tour.html";
    }
    else if (this.$route.params.name == "JXSB") {
      this.$refs.iframe.src = "http://gwc.bjthua.com/jxsbpano/com/tour.html";
    }
    else if (this.$route.params.name == "YMYMMJ") {
      this.$refs.iframe.src = "http://gwc.bjthua.com/ymymmjpano/com/tour.html";
    }
  },
  methods: {
    goAbout() {
      if (this.$route.params.name == "RZFY") {
        this.$router.replace("/about/" + this.$route.params.about);
      }
      else if (this.$route.params.name == "DXQNY") {
        this.$router.replace("/about6/" + this.$route.params.about);
      }
      else if (this.$route.params.name == "GDYH") {
        this.$router.replace("/about7/" + this.$route.params.about);
      }
      else if (this.$route.params.name == "JXSB") {
        this.$router.replace("/about8/" + this.$route.params.about);
      }
      else if (this.$route.params.name == "YMYMMJ") {
        this.$router.replace("/about5/" + this.$route.params.about);
      }
    },
  },
};
</script>

<style scoped>
.roam {
  width: 100%;
  height: 100vh;
  position: relative;
}

.roam img {
  width: 1.18rem;
  height: 0.48rem;
  position: absolute;
  left: 0.12rem;
  top: 0.06rem;
  z-index: 999;
}

.roam iframe {
  width: 100%;
  height: 100%;
}
</style>